import { createStore, applyMiddleware } from '@reduxjs/toolkit';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { getCookiesMiddleware } from 'redux-cookies';
import Cookies from 'cookies-js';
import rootReducer from "./reducers/reducer";
import {restoreSession} from "./slices/userSlice";

const store = createStore(
    rootReducer,
    composeWithDevTools(applyMiddleware(thunk, getCookiesMiddleware(Cookies)))
);

store.dispatch(restoreSession());
export default store;